import type { PDFFont } from "pdf-lib"

/* Yields code points for each character, replacing unsupported ones.
   If the font doesn't support a character, tries removing diacritics.
   If that doesn't work either, yields the fallback code point.

   https://github.com/Hopding/pdf-lib/issues/548

   */
function* yieldSupportedCodePoints(
  string: string,
  font: PDFFont,
  fallback: string
): Generator<number> {
  const charSet = font.getCharacterSet()
  const fallbackCodePoint = fallback.codePointAt(0) as number
  for (const codePointStr of string) {
    const codePoint = codePointStr.codePointAt(0)
    if (codePoint === undefined) {
      continue
    }
    if (!charSet.includes(codePoint)) {
      const withoutDiacriticsStr = codePointStr
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
      const withoutDiacritics = withoutDiacriticsStr.charCodeAt(0)
      if (charSet.includes(withoutDiacritics)) {
        yield withoutDiacritics
      } else {
        yield fallbackCodePoint
      }
    } else {
      yield codePoint
    }
  }
}

/* Checks for each code point whether the given font supports it.
   If not, tries to remove diacritics from said code point.
   If that doesn't work either, replaces the unsupported character with the fallback. */
export const ReplaceFontCharacters = (
  string: string,
  font: PDFFont,
  fallback = "?"
): string =>
  String.fromCodePoint(...yieldSupportedCodePoints(string, font, fallback))
